<template>
  <BaseModal :id="`modalDelete__${learningUnit.id}`" title="Delete this micro-credential" size="md">
    <p class="text-dark small">Are you sure that you want to delete this micro-credential?</p>
    <b-alert show class="d-flex align-items-center pl-2 align-content-center" variant="danger">
      <span>
        <strong class="d-block ml-3">{{ learningUnit.name }}</strong>
      </span>
    </b-alert>
    <p class="text-dark small">Click at the "Delete" button to delete this micro-credential.</p>
    <template slot="modal-footer">
      <b-button variant="link" class="btn-link-dark" @click.stop="hide()"> Cancel </b-button>
      <b-button variant="danger" @click.stop.prevent="deleteLearningUnit()"> Delete </b-button>
    </template>
  </BaseModal>
</template>

<script>
import { notificationMixin } from '@/mixins/notificationMixin';
import LearningUnit from '@/models/LearningUnit';
import BaseModal from '@/components/base-components/BaseModal';


export default {
  name: 'ModalDelete',

  components: {
    BaseModal
  },

  mixins: [notificationMixin],

  props: {
    learningUnit: {
      type: Object,
      default: null
    },
    index: {
      type: Number,
      default: null
    },
    routeAfterDelete: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      /**
       * TEMPORARY > identify type of modal
       *
       * @type {String}
       */
      modalType: null
    };
  },

  methods: {
    show(type) {
      this.modalType = type;
      this.$bvModal.show(`modalDelete__${this.learningUnit.id}`);
    },
    hide() {
      this.$bvModal.hide(`modalDelete__${this.learningUnit.id}`);
    },
    goNextPage() {
      this.$router.push({
        name: this.routeAfterDelete
      });
    },
    async deleteLearningUnit() {
      const deleted_at = new Date();
      try {
        await LearningUnit.api().deleteLearningUnit(this.learningUnit.id);

        this.$set(this.learningUnit, 'deleted_at', deleted_at);
        this.$set(this.learningUnit, '$index', this.index);
        this.$emit('isDeleted', this.learningUnit);
        this.hide();
        if (this.routeAfterDelete) {
          this.goNextPage();
        }
        this.notiSuccess('micro-credential', 'deleted');
      } catch (e) {
        console.log(e);
        this.notiError();
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
